exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nlegend item needs to be in the scope in order to control the font size in\nfullscreen dashboard mode\n*/\n.LegendItem {\n  font-size: 1.2em;\n  font-weight: bold;\n  transition: opacity 0.25s linear;\n  opacity: 1;\n}\n.Legend__LegendHeader___14YpV {\n  margin-top: 0.25em;\n  margin-bottom: 0.25em;\n}\n.Legend__LegendItem___1zU60.muted {\n  opacity: 0.4;\n}\n.Legend__Legend___2tUFa.Legend__none___3YdyC {\n  display: none;\n}\n.Legend__Legend___2tUFa.Legend__vertical___1BBNM {\n  display: flex;\n  flex-direction: column;\n  margin-right: 1em;\n}\n.Legend__Legend___2tUFa.Legend__horizontal___1TLy7 {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 1em;\n}\n", ""]);

// exports
exports.locals = {
	"LegendHeader": "Legend__LegendHeader___14YpV",
	"LegendItem": "Legend__LegendItem___1zU60",
	"Legend": "Legend__Legend___2tUFa",
	"none": "Legend__none___3YdyC",
	"vertical": "Legend__vertical___1BBNM",
	"horizontal": "Legend__horizontal___1TLy7"
};